// extracted by mini-css-extract-plugin
export default {"others":"Footer_others__DaEUQ","quickLinks":"Footer_quickLinks__TPjOB","socialIcon":"Footer_socialIcon__+HSoA"};